import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import KmxChevronLeftStroked from '@kmx/mui-icons/KmxChevronLeftStroked';
import KmxChevronRightStroked from '@kmx/mui-icons/KmxChevronRightStroked';

interface CarouselButtonProps {
    sectionIdPrefix: string;
    ariaText: string;
}

export const CarouselButtons = ({ sectionIdPrefix, ariaText }: CarouselButtonProps) => (
    <Stack direction="row" spacing={1}>
        <IconButton
            id={`${sectionIdPrefix}-carousel__prev`}
            variant="outlined"
            aria-label={`Go to previous ${ariaText} carousel item.`}
        >
            <KmxChevronLeftStroked />
        </IconButton>
        <IconButton
            id={`${sectionIdPrefix}-carousel__next`}
            variant="outlined"
            aria-label={`Go to next ${ariaText} carousel item.`}
        >
            <KmxChevronRightStroked />
        </IconButton>
    </Stack>
);
